import { FluentProvider, useThemeClassName } from "@fluentui/react-components";
import { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import ResizeObserver from "resize-observer-polyfill";
import { router } from "../router/router";
import store, { StorePersistor } from "../store";
import { SyntheiaBrandWebLight } from "../themes";

import "@asksyntheia/comments/style.css";
import "./index.css";

/* global document, Office, module, require, HTMLElement */

if (!window.ResizeObserver) window.ResizeObserver = ResizeObserver;

function UseGlobalTheming() {
  const classes = useThemeClassName();

  useEffect(() => {
    const classList = classes.split(" ");
    document.body.classList.add(...classList);

    return () => document.body.classList.remove(...classList);
  }, [classes]);

  return null;
}

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={StorePersistor}>
        <FluentProvider theme={SyntheiaBrandWebLight}>
          <UseGlobalTheming />
          <RouterProvider router={router} />
        </FluentProvider>
      </PersistGate>
    </Provider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
